import React from 'react'

export function arrowRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
      <path
        className="fill"
        d="M10.9775 7.435C11.29 7.7475 11.29 8.255 10.9775 8.5675L6.9775 12.5675C6.665 12.88 6.1575 12.88 5.845 12.5675C5.5325 12.255 5.5325 11.7475 5.845 11.435L9.28 8L5.8475 4.565C5.535 4.2525 5.535 3.745 5.8475 3.4325C6.16 3.12 6.6675 3.12 6.98 3.4325L10.98 7.4325L10.9775 7.435Z"
      />
    </svg>
  )
}
